/* eslint-disable no-unused-vars */
import { Activity } from '../../models/activity';
import { ApiServiceBase } from './base/api-service-base';

const baseEndpoint = 'activity';

export interface IActivityApiService {
	GetActivity(contactId: string): Promise<Activity[]>;
}

export class ActivityApiService extends ApiServiceBase implements IActivityApiService {
	public async GetActivity(contactId: string): Promise<any> {
		return await this.GetFromApi(`${baseEndpoint}/get/${contactId}`);
	}
}
